<span
  class="text-body-small text-po-error-base"
  data-testid="error"
  aria-atomic="true"
  aria-live="assertive"
>
  <ng-content />
</span>
